import React, { useCallback, useEffect, useState } from 'react'
import { paises } from '../../assets/paises';
import { Modal, Button, Form, Input, Radio, AutoComplete, Spin, Popconfirm, Tooltip } from 'antd';
import { message, DatePicker, Row, Col, Select } from 'antd';
import 'antd/dist/antd.css';
import './styles.css';
import * as ModalStatusAction from '../../redux/actions/modalStatus'
import * as PermissaoAction from '../../redux/actions/permissao'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import axios from 'axios';
import api from '../../services/api';
import Checkbox from 'antd/lib/checkbox/Checkbox';
import MaskedInput from 'react-input-mask'
import moment from 'moment';
import { dadosCadastraisService } from '../../services/Dados-Cadastrais-Service/dados-cadastrais-service';
import { ruleDataInvalida } from '../../utils/custom-rules-antd';
import debounce from 'lodash.debounce';
import { isUndefined } from 'lodash';
import MaskedTextInput from 'react-text-mask'
import { onKeyDownBloquearDigitosPorLength, validarTelefoneCelular } from '../../utils/telefone';
import { InfoCircleOutlined } from '@ant-design/icons';

interface ModalPreCadastroProps {
    modalStatus?: any,
    permissao?: any,
    setPreCadastroModal?: any
}

const ModalPreCadastro: React.FC<ModalPreCadastroProps> = (prop) => {
    interface PreCadastro {
        CadastroID?: number,
        Nome: string,
        DataNascimento: Date,
        Pais: string,
    }

    useEffect(() => {
        // setCheckedResideNoBrasil(false);
        form.resetFields();
        buscaPaises();
    }, [prop.modalStatus[0].visiblePreCadastro])

    let visible = prop.modalStatus[0].visiblePreCadastro
    // const [checkedResideNoBrasil, setCheckedResideNoBrasil] = useState(false);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [optionsInput, setOptionsInput] = useState<any[]>([]);
    const [popConfirmVisible, setPopConfirmVisible] = useState(false);
    const [jaExisteIdentico, setJaExisteIdentico] = useState(false);
    const [cadastroSemelhanteIdentico, setCadastroSemelhanteIdentico] = useState<any[]>();
    const [loadinCoutry,setLoadinCoutry] = useState<any>();
    const [paises, setPaises] = useState<any[]>([]);


    var options: any[] = [];
    const handleCancel = () => {
        prop.setPreCadastroModal(false);
    };

    const debouncedSearch = useCallback(
        debounce(nextValue => buscarMigrante(), 500),
        [], // will be created only once initially
    );

    const handleSearch = (event: any) => {
        const { value: nextValue } = event;
        debouncedSearch(nextValue);
    };

    const buscarMigrante = () => {
        if (!form.getFieldValue("nome")) { setOptionsInput([]); return; }
        if (form.getFieldValue("nome").length <= 0) { setOptionsInput([]); return; }

        dadosCadastraisService.getByNomeSemelhante(form.getFieldValue("nome"))
            .then((response) => {
                if (response.data)
                    configOptions(response.data)
            })
            .finally(() => {
            })
    }

    const renderLabelCadastrosSemelhantes = () => (
        <span className='cadastros_semelhantes'>
            CADASTROS SEMELHANTES:
        </span>
    );

    const renderPopConfirmTitleCadastrosSemelhantes = () => (
        <>
            Encontramos um cadastro semelhante na base de dados. <br />
            Cadastro(s) encontrado(s):  <br />
            {cadastroSemelhanteIdentico?.map(c => (
                <> <span>-{c.nome}</span> - {c.pais} - {moment(c.dataNascimento).format("DD/MM/YYYY")}<br /> </>
            )
            )}
            Deseja finalizar o pré-cadastro?
        </>
    );

    const renderMessageCadastrosIdenticos = (data: any[]) => {
        return (
            <>
                Não é possível realizar o cadastro pois encontramos um registro idêntico na base de dados. Cadastro(s) encontrado(s):  <br />
                {data?.map(c => (
                    <> <span>-{c.nome}</span> - {c.pais} - {moment(c.dataNascimento).format("DD/MM/YYYY")}<br /> </>
                )
                )}
            </>
        );
    }

    const configOptions = (dados: any[]) => {
        options = dados.map((a: any) => {
            let labelDataNascimento = moment(a.dataNascimento).isValid() ? " - " + moment(a.dataNascimento).format("DD/MM/YYYY") : ""
            return { label: a.nome + labelDataNascimento + ' - ' + a.pais }
        })
        if (dados.length === 0)
            setOptionsInput([])
        else
            setOptionsInput([{ label: renderLabelCadastrosSemelhantes(), options }])
    }


    const validarSemelhanteIdentico = () => {
        form.validateFields().then(() => {
            setPopConfirmVisible(false);
            message.destroy();
            let values = form.getFieldsValue();
            if (!isUndefined(values.nome) && !isUndefined(values.dataNascimento) && !isUndefined(values.pais) && !isUndefined(values.telefone)) {
                setLoading(true);
                api.post("DadosCadastrais/validaridenticosemelhante", {
                    Nome: values.nome,
                    DataNascimento: values.dataNascimento ? moment(values.dataNascimento, "DD/MM/YYYY").format("YYYY-MM-DD") : undefined,
                    Pais: values.pais,
                })
                    .then((response) => {
                        if (response.data.valido) {
                            setPopConfirmVisible(false);
                            setJaExisteIdentico(false);
                            onFinish();
                        }
                        else {
                            setCadastroSemelhanteIdentico(response.data.cadastro)
                            if (response.data.ehIdentico) {
                                message.error({ content: renderMessageCadastrosIdenticos(response.data.cadastro), duration: 10, key: 1 })
                                setJaExisteIdentico(true);
                            }
                            else {
                                // message.warning({ content: 'Encontramos um cadastro semelhante na base de dados. Cadastro encontrado: ' + response.data.cadastro, duration: 10, key: 1 })
                                setPopConfirmVisible(true);
                                setJaExisteIdentico(false);
                            }
                        }
                    })
                    .catch((err) => {
                        message.error(err?.response?.data || 'Falha na requisição', 10)
                    })
                    .finally(() => setLoading(false))
            }
        })
    };


    const onFinish = () => {
        let values = form.getFieldsValue();
        var usuarioLogado = JSON.parse(sessionStorage.getItem('usuarioLogado') || '{}')
        setPopConfirmVisible(false);
        api.post("DadosCadastrais", {
            CadastroID: undefined,
            Nome: values.nome,
            DataNascimento: values.dataNascimento ? moment(values.dataNascimento, "DD/MM/YYYY").format("YYYY-MM-DD") : undefined,
            Pais: values.pais,
            ChefeFamilia: false,
            Telefone: values.telefone,
            UsuarioPreCadastroID: usuarioLogado.usuarioID,
            UsuarioPreCadastroNome: usuarioLogado.nomeUsuario,
            // ResideNoBrasil: checkedResideNoBrasil
        })
            .then((response) => {
                message.success({ content: 'Pré-Cadastro realizado com Sucesso', duration: 5, key: 2 })
                prop.setPreCadastroModal(false)
            })
            .catch((err) => {
                message.error({ content: err?.response?.data || 'Falha na requisição', duration: 5, key: 2 })
            })
            .finally(() => {
                setLoading(false)
            })
    };

    const buscaPaises = async () => {
        setLoadinCoutry(true);

       
          await api.get("Localidade/getPaises").then(({data}) => {
            if (Array.isArray(data)) {
              setPaises(data);
            } else {
              setPaises([]);
            }
            setLoadinCoutry(false);
    
        }).finally(() => {
            setLoadinCoutry(false);
    
        })

    
    }

    const attPais = (cidadeName:any) =>{
        
        form.setFieldsValue({"pais":cidadeName?.toUpperCase()});
        
    }

    const onFinishFailed = (errorInfo: any) => {
    };

    return (
        <Modal
            visible={visible}
            title="Pré-Cadastro"
            onCancel={handleCancel}
            footer={null}
            width={700}
        >
            <Form
                name="basic"
                form={form}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                onChange={() => setPopConfirmVisible(false)}
            // onBlur={validarSemelhanteIdentico}
            >
                <Spin spinning={loading}>

                    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                        <Col className="gutter-row" span={24}>
                            <Form.Item
                                label="Nome"
                                name="nome"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Por favor insira um nome!',
                                    }
                                ]}
                            >
                                <AutoComplete
                                    options={optionsInput}
                                    placeholder="Informe o Nome"
                                    onSearch={handleSearch}
                                    onFocus={(e: any) => {
                                        buscarMigrante()
                                    }}
                                    onSelect={() => { return; }}
                                    onChange={() => { return; }}
                                    onBlur={() => setOptionsInput([])}
                                >
                                </AutoComplete>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                        <Col className="gutter-row" span={24}>
                        <Form.Item name="pais" label={(<>
                            <span style={{'marginRight':'5px'}}>País</span>
                            <Tooltip title="1- Caso necessite visualizar o nome dos países em portugês, traduza a página com o tradutor padrão do navegador e clique no campo novamente.">
                                 <InfoCircleOutlined style={{'color':'blue'}}/>
                            </Tooltip>
                            </>)} >
                           
                                {paises?.length > 0 ?
                                    <Spin spinning={loadinCoutry}>

                                        <Select
                                            showSearch
                                            optionFilterProp="children"
                                            placeholder="selecione um país"
                                            onChange={(e)=> attPais(e)}
                                        >
                                            {paises?.map((p: any, index: any) => <Select.Option key={index} value={p.name}>{p.name?.toUpperCase()}</Select.Option>)}
                                        </Select>
                                    </Spin> : <Input
                                        >
                                    </Input>
                                }
                                
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                        <Col className="gutter-row" span={24}>
                            <Form.Item
                                label="Data Nascimento"
                                name="dataNascimento"
                                rules={[{ validator: ruleDataInvalida },
                                {
                                    required: true,
                                    message: 'Por favor insira a data de nascimento!',
                                }]}
                            >
                                <MaskedInput className="ant-input" placeholder="Informe a Data" mask="99/99/9999" />
                                {/* <DatePicker placeholder="Informe a Data de Nascimento do Migrante" format="DD/MM/YYYY" /> */}
                            </Form.Item>
                        </Col>
                        {/* <Col className="gutter-row" span={9}>
                        <Form.Item
                            label="Reside no Brasil"
                            name="resideNoBrasil"
                        >
                            <Checkbox checked={checkedResideNoBrasil} onChange={(e: any) => { setCheckedResideNoBrasil(e.target.checked); }}></Checkbox>
                        </Form.Item>
                    </Col> */}
                    </Row>
                    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                        <Col className="gutter-row" span={24}>
                            <Form.Item
                                label="Telefone"
                                name="telefone"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Por favor insira o telefone!',
                                    },
                                    {
                                        validator: (_, value) => validarTelefoneCelular(value), validateTrigger: "onSubmit"
                                    }
                                ]}>
                                <MaskedTextInput className="ant-input" placeholder="Informe o Telefone para contato"
                                    onKeyDown={(e: any) => { onKeyDownBloquearDigitosPorLength(e, 11) }}
                                    mask={(value: any) => {
                                        if (value && value.replace(/\D/g, '').length >= 11) {
                                            return [/\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
                                        } else {
                                            return [/\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
                                        }
                                    }}
                                />

                            </Form.Item>
                        </Col>
                    </Row>
                    <Form.Item>
                        {prop.permissao[0].permissaoAcesso?.cadastrar === true ?
                            <Popconfirm
                                title={renderPopConfirmTitleCadastrosSemelhantes}
                                onConfirm={onFinish}
                                okText="Sim"
                                cancelText="Não"
                                onCancel={() => { setPopConfirmVisible(false) }}
                                visible={popConfirmVisible}
                            >
                                <Button className="button-pre-cadastro" type="primary" htmlType="button" onClick={validarSemelhanteIdentico} >
                                    Finalizar
                                </Button>
                            </Popconfirm>
                            : null}
                    </Form.Item>
                </Spin>
            </Form>
        </Modal >
    );
}

const mapStateToProps = (state: any) => ({
    modalStatus: state.modalStatus,
    permissao: state.permissao
})

const mapDispatcToProps = (dispatch: any) => {
    return bindActionCreators(Object.assign({}, PermissaoAction, ModalStatusAction), dispatch);
}
export default connect(mapStateToProps, mapDispatcToProps)(ModalPreCadastro);